export default "__VITE_ASSET__BTO8tZ$q__"